module.exports = __webpack_public_path__ + "static/media/external_link_icon.8778dd00.svg";